__turbopack_context__.v({
  "mantine-Box-root": "Box-module__g0a_NG__mantine-Box-root",
  "root": "Box-module__g0a_NG__root",
});
